import StickyProfileBanner from 'components/ProfileBanner/StickyProfileBanner/StickyProfileBanner';

export default StickyProfileBanner;
